"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = require("babel-runtime/helpers/extends");

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = require("babel-runtime/core-js/object/get-prototype-of");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require("babel-runtime/helpers/createClass");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require("babel-runtime/helpers/possibleConstructorReturn");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require("babel-runtime/helpers/inherits");

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FacetItem = function (_React$PureComponent) {
    (0, _inherits3.default)(FacetItem, _React$PureComponent);

    function FacetItem() {
        var _ref;

        var _temp, _this, _ret;

        (0, _classCallCheck3.default)(this, FacetItem);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = FacetItem.__proto__ || (0, _getPrototypeOf2.default)(FacetItem)).call.apply(_ref, [this].concat(args))), _this), _this.onChange = function (e) {
            _this.props.onChange((0, _extends3.default)({}, _this.props.item, { checked: e.target.checked }), e.target);
        }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
    }

    (0, _createClass3.default)(FacetItem, [{
        key: "render",
        value: function render() {
            var _props$item = this.props.item,
                groupName = _props$item.groupName,
                name = _props$item.name,
                displayName = _props$item.displayName,
                value = _props$item.value,
                count = _props$item.count,
                checked = _props$item.checked,
                anySelected = _props$item.anySelected;

            var showPlus = anySelected && !checked;
            return _react2.default.createElement(
                "div",
                { className: "form__checkbox" },
                _react2.default.createElement("input", { key: name, id: name, name: groupName,
                    "data-filter": "array",
                    "data-query-target": "#mainContent",
                    value: value, checked: checked || false, type: "checkbox",
                    onChange: this.onChange }),
                _react2.default.createElement(
                    "label",
                    { htmlFor: name },
                    displayName,
                    _react2.default.createElement(
                        "small",
                        { className: "normal" },
                        "(",
                        showPlus && _react2.default.createElement(
                            "span",
                            null,
                            "+"
                        ),
                        count || 0,
                        ")"
                    )
                )
            );
        }
    }]);
    return FacetItem;
}(_react2.default.PureComponent);

exports.default = FacetItem;
module.exports = exports["default"];


//////////////////
// WEBPACK FOOTER
// ./Scripts/app/facets/components/facet-item.js
// module id = 413
// module chunks = 0 1